
<div style="text-align: right; cursor: pointer;">
        <i class="material-icons __close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>
<div class="button-container">
    <button *ngIf="!displayComponentImageType && showDrawButton" mat-raised-button class="button" (click)="editPhoto()"><i class="material-icons button__icon">edit</i><span>Draw</span></button>
    <button *ngIf="!equipmentID && !viewMode" mat-raised-button class="button" (click)="fileInput.click()"><i class="material-icons button__icon">cloud_upload</i><span>Replace Photo</span></button>
      <input style="display: none;" type="file"
         #fileInput accept="image/*"
         (change)="replacePhotoClicked($event)"
         hidden>
    <button *ngIf="!equipmentID && !displayComponentImageType && showDeleteButton" mat-raised-button class="button" (click)="deletePhoto()"><i class="material-icons button__icon" >delete</i><span>Delete</span></button>
  </div>
  
  <div class="photo-container">
    <div>
      <ng-container *ngIf="loadingRow">
        <!-- <mat-spinner></mat-spinner> -->
    </ng-container>
    </div>
    <img class="photo-container__photo" [src]="sanitize(photo)" *ngIf="!photoLoading && !imgUrl" [@fadeIn]/>
    <img class="photo-container__photo" [src]="photo" *ngIf="!photoLoading && imgUrl" [@fadeIn]/>
    <div class="center" *ngIf="photoLoading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <!-- <input style="display: none;" type="file"
         #fileInput
         (change)="replacePhotoClicked($event)"> -->
